import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";

import { DatePicker } from "../../containers/common/date-picker";
import {
  BookingLocationPresenter,
  inflateBookingLocationPresenter,
} from "../../presenters/booking-location";
import { ICategory } from "../../services/api/category-list";
import { ITherapistAvailability } from "../../services/api/therapists";
import { IRootState } from "../../store/index";
import {
  actionCreators as therapistsActions,
  getTherapistsAvailabilityForDay,
} from "../../store/therapists/actions";

import { config } from "../../config";

interface IProps {
  isCategoryPreselected?: boolean;
  category: ICategory;
  onClick(justclose?: boolean): void;
  trackFocus(): void;
  trackChange(value: string | undefined): void;
  isShowTooltip: boolean;
}

interface IReduxProps {
  availableDates: ITherapistAvailability;
  bookingLocation?: BookingLocationPresenter;
  selectedDate?: string;
}

interface IState {
  isDisabled: boolean;
}

type Props = IProps & IReduxProps & { dispatch: Dispatch<any> };

class SearchDateContainer extends React.Component<Props, IState> {
  public state: IState = {
    isDisabled: false,
  };

  public componentDidMount() {
    if (
      !this.props.bookingLocation ||
      !this.props.category ||
      !this.props.isCategoryPreselected
    ) {
      this.setState({ isDisabled: true });
    }
  }

  public componentDidUpdate(prevProps: Props) {
    if (
      this.props.bookingLocation !== prevProps.bookingLocation &&
      this.props.bookingLocation &&
      (this.props.category || this.props.isCategoryPreselected) &&
      this.state.isDisabled
    ) {
      this.setState({ isDisabled: false });
    } else if (
      this.props.bookingLocation !== prevProps.bookingLocation &&
      !this.props.bookingLocation &&
      !this.state.isDisabled
    ) {
      this.setState({ isDisabled: true });
    }

    if (
      this.props.category !== prevProps.category &&
      this.props.category &&
      this.props.bookingLocation &&
      this.state.isDisabled
    ) {
      this.setState({ isDisabled: false });
    } else if (
      this.props.category !== prevProps.category &&
      !this.props.category &&
      !this.state.isDisabled
    ) {
      this.setState({ isDisabled: true });
    }
  }

  public selectDate = (date: string): void => {
    const category = this.props.category ? this.props.category.id : undefined;
    this.props.dispatch(therapistsActions.setDate(date));
    this.props.dispatch(getTherapistsAvailabilityForDay(date, category));
  };

  /**
   * Call callback on datepicker input click
   * logic to show or hide tooltip
   */
  public checkForm = () => {
    if (
      !this.props.bookingLocation ||
      (!this.props.category && !this.props.isCategoryPreselected)
    ) {
      this.props.onClick();
    } else if (this.state.isDisabled || this.props.isShowTooltip) {
      this.props.onClick(true);
    }
  };

  /**
   * Render calendar
   */
  public render() {
    return (
      <DatePicker
        disabled={this.state.isDisabled}
        maxDaysRange={config.dateTime.date.range.days}
        onSelectDate={this.selectDate}
        selectedDate={this.props.selectedDate}
        onClick={() => {
          this.checkForm();
          this.props.trackFocus();
        }}
        trackChange={this.props.trackChange}
      />
    );
  }
}

// store
const mapStateToProps = (state: IRootState): IReduxProps => {
  return {
    availableDates: state.therapistsState.selectedTherapistAvailableDates,
    ...(state.postcodesState.bookingLocation && {
      bookingLocation: inflateBookingLocationPresenter(
        state.postcodesState.bookingLocation,
      ),
    }),
    selectedDate: state.therapistsState.selectedDate,
  };
};

const store =
  connect<IReduxProps, {}, {}, IRootState>(mapStateToProps)(
    SearchDateContainer,
  );

export { store as SearchDateContainer };
